import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  role: null,
  jwtToken: null,
  userId: null,
  fname: null,
  lname: null,
  photo: null,
  mobileNumber: null,
  zone: null,
  alloted_to: null,
  write_permission: null,
  read_permission: null,
  is_active: null,
};

export const isAuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthLogin: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetState: () => initialState,
  },
});

export const { setAuthLogin, resetState } = isAuthSlice.actions;

export default isAuthSlice.reducer;
